import Swiper from 'swiper';
import {mediaQueryBreakpointMD, mediaQueryBreakpointSM} from "../Utils/Utils.js";

const ACFBlockRecipeContent = (domEl) => {

	const swiperEl = domEl.querySelector('.swiper');
	if(!swiperEl) {
		return;
	}

	const options = {
		loop: false,
		autoplay: false,
		speed: 300,
		slidesPerView: 1.05,
		spaceBetween: 12,
		//autoHeight: true,

		breakpoints: {
			[mediaQueryBreakpointSM]: {
				slidesPerView: 2,
				//spaceBetween: 20,
				//autoHeight: false,
			},
			[mediaQueryBreakpointMD]: {
				slidesPerView: 3,
				//spaceBetween: 20,
				//autoHeight: false,
			}
		}
	};
	const swiper = new Swiper(swiperEl, options);

	const handleSwiperChange = () => {
		renderActiveMarking(swiper.realIndex);
	}
	swiper.on('slideChange', handleSwiperChange);


	const handleClick = (e) => {
		//e.preventDefault();
		const index = parseInt(e.currentTarget.dataset.targetIndex);
		render(index);
	};

	const renderActiveMarking = (index) => {
		swiperEl.querySelectorAll('.swiper-slide-active').forEach(slide => slide.classList.remove('swiper-slide-active'));
		swiperEl.querySelector('.swiper-slide[data-target-index="'+index+'"]').classList.add('swiper-slide-active');

		swiperEl.querySelectorAll('.information-nav button.js-active').forEach(btn => btn.classList.remove('js-active'));
		swiperEl.querySelector('.information-nav button[data-target-index="'+index+'"]').classList.add('js-active');
	};

	const render = (index) => {

		if(window.innerWidth >= mediaQueryBreakpointMD) {
			renderActiveMarking(index);
		}
		else {
			swiper.slideTo(index);
		}
	}

	swiperEl.querySelectorAll('.swiper-slide,.information-nav button').forEach(el => el.addEventListener('click', handleClick));

};

export default ACFBlockRecipeContent;